export const isEmptyString = (str) => {
    return !str || str.trim().length === 0;
};
